import React from 'react';
export function EmailClickIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5h18v.586l-3.707 3.707 1.414 1.414L21 8.414V13h2V5a2 2 0 00-2-2H3a2 2 0 00-2 2v14a2 2 0 002 2h9v-2H3v-.062L8.674 13.7l2.138 2.026 1.376-1.452L3 5.57V5zm4.219 7.322L3 16.216V8.325l4.219 3.997z"
  }), React.createElement("path", {
    d: "M21 21.5l-1.5 1-2-3.5-2.5 2v-9l7.5 5.5-3.5.5 2 3.5z"
  }));
}